<div>
  <dx-data-grid #grid id="gridContainer" [dataSource]="datos" [(selectedRowKeys)]="selectedRowKeys" [keyExpr]="id"
    [masterDetail]="{ enabled: Detail.detail, template: 'detail'}" [showBorders]="true" [columnAutoWidth]="true"
    [showRowLines]="Color.filas" [showColumnLines]="Color.columnas" [remoteOperations]="remoteOperations"
    [rowAlternationEnabled]="Color.alternar" (onToolbarPreparing)="onToolbarPreparing($event)"
    (onSelectionChanged)="onSelectionChanged($event)" (onContentReady)="onContentReady($event)"
    (onInitialized)="onInitializedMaster($event)" (onRowUpdated)="OnRowUpdated($event)"
    (onRowInserted)="OnRowInserted($event)" (onRowRemoved)="OnRowRemoved($event)"
    [columnHidingEnabled]="columnHiding.hide" (onRowUpdating)="onRowUpdating($event)"
    (onCellPrepared)="onCellPrepared($event)" (onRowPrepared)="onRowPrepared($event)"
    (onInitNewRow)="OnInitNewRow($event)">
    <!-- -------------------- EDITAR ------------------------------------------>
    <dxo-editing [mode]="Editing.mode" [allowUpdating]="Editing.allowupdate" [allowDeleting]="Editing.allowDeleting"
      [allowAdding]="Editing.allowAdding"></dxo-editing>

    <!-- -------------------- CHECKBOX ------------------------------------------>
    <dxo-selection [mode]="Checkbox.checkboxmode"></dxo-selection>

    <!-- -------------------- SELECCIONADOR DE COLUMNAS ------------------------------------------>
    <dxo-column-chooser [enabled]="Columnchooser.columnchooser" mode="select"></dxo-column-chooser>


    <!-- -------------------- PAGINACION ------------------------------------------>
    <dxo-pager infoText="Página #{0}. Total: {1} ({2} elementos)" [showPageSizeSelector]="true"
      [allowedPageSizes]="gridOptions.pageSize" [showInfo]="true"></dxo-pager>
    <dxo-paging [pageSize]="gridOptions.paginacion"></dxo-paging>


    <!-- -------------------- FILTROS ------------------------------------------>

    <dxo-search-panel [visible]="searchPanel.visible" [width]="searchPanel.width"
      [placeholder]="searchPanel.placeholder"></dxo-search-panel>
    <dxo-header-filter [visible]="searchPanel.filterHeader" [allowSearch]="true"></dxo-header-filter>
    <!-- <dxo-header-filter [visible]="true"></dxo-header-filter> -->
    <dxo-filter-row [visible]="searchPanel.filterRow"></dxo-filter-row>
    <!-- <dxo-filter-panel [visible]="true"></dxo-filter-panel> -->

    <!-- -------------------- SCROLL ------------------------------------------>

    <dxo-scrolling [mode]="scroll.mode" [rowRenderingMode]="scroll.mode"></dxo-scrolling>
    <dxo-scrolling [columnRenderingMode]="scroll.mode" [scrollByContent]="true"></dxo-scrolling>

    <!-- -------------------- EXPORT ------------------------------------------>

    <dxo-export [fileName]="exportExcel.fileName" [enabled]="exportExcel.enabled"></dxo-export>

    <!-- -------------------- COLUMNAS ------------------------------------------>

    <dxi-column *ngFor="let column of columns" [dataField]="column.dataField" [caption]="column.caption"
      [width]="column.width" [groupIndex]="column.groupIndex" [cellTemplate]="column.cellTemplate"
      [hidingPriority]="column.hiddingPriority" [allowEditing]="column.allowEditing" [dataType]="column.dataType"
      [format]="column.format" [editorOptions]="column.editorOptions" [alignment]="column.side">
    </dxi-column>


    <!-- --- TEMPLATES PARA COLUMNAS QUE NECESITAN DE ALGUN CONTROL O FUNCIONALIDAD EN ESPECIAL --- -->
    <div class='text-left' *dxTemplate="let data of 'templateBotones'">
      <button class="btn-circle btn-hover" title="Editar"
        style='background-color: #eee; border-color: #eee; border-radius: 60px; width: 35px; height: 25px; margin-right: 5px; padding-top: 3px;'
        (click)="Modificar(data)">
        <!-- <button class="btn-circle" title="Editar" style='' (click)="Modificar(data)"> -->
        <!-- <i class="material-icons" style="color: #333; font-size: 18px;">create</i> -->
        <mat-icon svgIcon="heroicons_outline:eye" style="font-size: 12px;"></mat-icon>
      </button>
      &nbsp;
      <!-- <button class="btn-circle" title="Eliminar" style='background-color: #cccccc; border-color: #cccccc; border-radius: 60px; width: 20px; height: 20px;' (click)="Eliminar(data)"> -->
      <button class="btn-circle btn-hover" title="Eliminar"
        style='background-color: #eee; border-color: #eee; border-radius: 60px; width: 35px; height: 25px; margin-right: 5px; padding-top: 3px;'
        (click)="Eliminar(data)">
        <!-- <button class="btn-circle btn-hover" title="Eliminar" style='' (click)="Eliminar(data)"> -->
        <!-- <i class="material-icons" style="color: #333; font-size: 18px;">clear</i> -->
        <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>

    <div class='text-left' *dxTemplate="let data of 'templateEditar'">
      <!-- - Hola {{ data.key.accion }} - -->

      <ng-container *ngIf="data.key.accion == 1">
        <dx-drop-down-button [splitButton]="true" [useSelectMode]="false" text="Opciones" [items]="downloadsBorrador"
          displayExpr="name" keyExpr="id" (onButtonClick)="onButtonClick($event, data)"
          (onItemClick)="onItemClick($event, data)"></dx-drop-down-button>
      </ng-container>

      <ng-container *ngIf="data.key.accion == 2">
        <dx-drop-down-button [splitButton]="true" [useSelectMode]="false" text="Opciones" [items]="downloadsTimbrada"
          displayExpr="name" keyExpr="id" (onButtonClick)="onButtonClick($event, data)"
          (onItemClick)="onItemClick($event, data)"></dx-drop-down-button>
      </ng-container>

      <ng-container *ngIf="data.key.accion == 4">
        <dx-drop-down-button [splitButton]="true" [useSelectMode]="false" text="Opciones" [items]="downloadsCancelada"
          displayExpr="name" keyExpr="id" (onButtonClick)="onButtonClick($event, data)"
          (onItemClick)="onItemClick($event, data)"></dx-drop-down-button>
      </ng-container>
    </div>

    <div class='text-right' *dxTemplate="let data of 'MoneyFormat'" [alignment]="right">
      {{data.data.precio | currency}}
    </div>

    <div class='text-left' *dxTemplate="let data of 'templateEstatus'" [alignment]="center">
      <mat-icon svgIcon="heroicons_outline:x" class="red-icon h-medium" *ngIf="data.data.descripcion == 'Cancelada'"
        #tooltip="matTooltip" matTooltip="CFDI cancelado" [matTooltipPosition]="'right'" matTooltipHideDelay="3000">
      </mat-icon>

      <mat-icon svgIcon="mat_outline:save" class="gray-icon h-medium" *ngIf="data.data.descripcion == 'Creado'"
        #tooltip="matTooltip" matTooltip="Borrador" [matTooltipPosition]="'right'" matTooltipHideDelay="3000">
      </mat-icon>

      <mat-icon svgIcon="heroicons_outline:check" class="green-icon h-medium"
        *ngIf="data.data.descripcion == 'Timbrada'" #tooltip="matTooltip" matTooltip="CFDI Timbrado"
        [matTooltipPosition]="'right'" matTooltipHideDelay="3000">
      </mat-icon>

    </div>
    <!-- -------------------- TEMPLATE FOTO ------------------------------------------>

    <div *dxTemplate="let data of 'foto'" class="foto">
      <a [href]="data.value" data-lightbox="avatar">
        <img id="myImg" class="foto-ad" [src]="data.value" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE COLOR ------------------------------------------>

    <div *dxTemplate="let data of 'color'">
      <div [style.background-color]="data.value" class="cuadrado"></div>
    </div>

    <!-- -------------------- TEMPLATE PDF ------------------------------------------>

    <div *dxTemplate="let data of 'pdf'" class="foto">
      <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docpdf.png"
        (click)="dialog.open(Gridlightbox)" />
      <ng-template #Gridlightbox>
        <div>
          <button type="button" class="close linea" aria-label="Close" [mat-dialog-close]>
            <span aria-hidden="true">&times;</span>
          </button>
          <pdf-viewer class="pdf" [src]="data.value" [original-size]="false" [autoresize]="true">
          </pdf-viewer>
        </div>
      </ng-template>
    </div>

    <!-- -------------------- TEMPLATE EXCEL ------------------------------------------>
    <div *dxTemplate="let data of 'excel'" class="foto">
      <a [href]="data.value">
        <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docEXCEL.png" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE WORD ------------------------------------------>
    <div *dxTemplate="let data of 'word'" class="foto">
      <a [href]="data.value">
        <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docword.png" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE POWER POINT ------------------------------------------>
    <div *dxTemplate="let data of 'powerpoint'" class="foto">
      <a [href]="data.value">
        <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docPP.png" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE TXT ------------------------------------------>
    <div *dxTemplate="let data of 'txt'" class="foto">
      <a [href]="data.value">
        <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/doctxt.png" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE XML ------------------------------------------>
    <div *dxTemplate="let data of 'xml'" class="foto">
      <a [href]="data.value" target="_blank">
        <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docXML.png" />
      </a>
    </div>

    <!-- -------------------- TEMPLATE TOTAL DE REGISTROS ------------------------------------------>
    <div class="totalcolor" [ngClass]="{'totalcolorgris': Color.color === 'gris'}"
      *dxTemplate="let data of 'Totalderegistros'">
      <div class="informer">
        <h2 class="totalcount">{{datos && !totalRegistros ? datos.length : totalRegistros}}</h2>
        <span class="name">Registros</span>
      </div>
    </div>

    <!-- -------------------- TEMPLATE REGISTROS SELECCIONADOS ------------------------------------------>
    <div class="countcolor" *dxTemplate="let data of 'Contarseleccionados'">
      <div class="informer">
        <h2 class="countcount">{{contador}}</h2>
        <span class="countname">Seleccionados</span>
      </div>
    </div>

    <div *dxTemplate="let data of 'detail'">
      <dx-data-grid #griddetail id="gridContainerDetail" [dataSource]="data.data.detalle" [showBorders]="true"
        [keyExpr]="KeyExprDetail" [columnAutoWidth]="true" [showRowLines]="Color.filas"
        [showColumnLines]="Color.columnas" [selectedRowKeys]="selectedRowKeysDetail"
        [remoteOperations]="remoteOperations" [rowAlternationEnabled]="Color.alternar"
        (onToolbarPreparing)=" onToolbarPreparingDetail($event)"
        (onSelectionChanged)="onSelectionChangedDetail($event, data.data)"
        (onContentReady)="onContentReadyDetail($event)" [columnHidingEnabled]="columnHiding.hide"
        (onRowUpdating)=" onRowUpdatingDetail($event)" (onCellPrepared)="onCellPreparedDetail($event)"
        (onRowPrepared)="onRowPreparedDetail($event)">
        <!-- -------------------- EDITAR ------------------------------------------>
        <dxo-editing [mode]="Editing.mode" [allowUpdating]="Editing.allowupdate"></dxo-editing>
        <!-- <dxo-editing [mode]="Editing.mode" [allowUpdating]="Editing.allowupdate" [allowDeleting]="Editing.allowDeleting" [allowAdding]="Editing.allowAdding"></dxo-editing> -->
        <!-- -------------------- CHECKBOX ------------------------------------------>
        <dxo-selection *ngIf="CheckboxDetail" [mode]="CheckboxDetail.checkboxmode"></dxo-selection>

        <!-- -------------------- SELECCIONADOR DE COLUMNAS ------------------------------------------>
        <dxo-column-chooser [enabled]="Columnchooser.columnchooser" mode="select"></dxo-column-chooser>


        <!-- -------------------- PAGINACION ------------------------------------------>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="gridOptions.pageSize" [showInfo]="true">
        </dxo-pager>
        <dxo-paging [pageSize]="gridOptions.paginacion"></dxo-paging>

        <!-- -------------------- FILTROS ------------------------------------------>

        <dxo-search-panel [visible]="searchPanel.visible" [width]="searchPanel.width"
          [placeholder]="searchPanel.placeholder"></dxo-search-panel>
        <dxo-header-filter [visible]="searchPanel.filterHeader" [allowSearch]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="searchPanel.filterRow"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>

        <!-- -------------------- SCROLL ------------------------------------------>

        <dxo-scrolling [mode]="scroll.mode" [rowRenderingMode]="scroll.mode"></dxo-scrolling>
        <dxo-scrolling [columnRenderingMode]="scroll.mode" [scrollByContent]="true"></dxo-scrolling>

        <!-- -------------------- EXPORT ------------------------------------------>

        <dxo-export [fileName]="exportExcel.fileName" [enabled]="exportExcel.enabled"></dxo-export>

        <!-- -------------------- COLUMNAS ------------------------------------------>

        <dxi-column *ngFor="let column of columnsdetail" [dataField]="column.dataField" [caption]="column.caption"
          [width]="column.width" [groupIndex]="column.groupIndex" [cellTemplate]="column.cellTemplate"
          [hidingPriority]="column.hiddingPriority" [allowEditing]="column.allowEditing" [dataType]="column.dataType"
          [format]="column.format">
          <!--dxi-validation-rule *ngIf="column.allowEditing === true"
          type="pattern"
          [pattern]="column.pattern"
          [message]="column.messageError" >
          </dxi-validation-rule-->
        </dxi-column>

        <!-- -------------------- TEMPLATE FOTO ------------------------------------------>

        <div *dxTemplate="let data of 'foto'" class="foto">
          <a [href]="data.value" data-lightbox="avatar">
            <img id="myImg" class="foto-ad" [src]="data.value" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE PDF ------------------------------------------>

        <div *dxTemplate="let data of 'pdf'" class="foto">
          <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docpdf.png"
            (click)="dialog.open(Gridlightbox)" />
          <ng-template #Gridlightbox>
            <div>
              <button type="button" class="close linea" aria-label="Close" [mat-dialog-close]>
                <span aria-hidden="true">&times;</span>
              </button>
              <pdf-viewer class="pdf" [src]="data.value" [original-size]="false" [autoresize]="true">
              </pdf-viewer>
            </div>
          </ng-template>
        </div>

        <!-- -------------------- TEMPLATE EXCEL ------------------------------------------>
        <div *dxTemplate="let data of 'excel'" class="foto">
          <a [href]="data.value">
            <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docEXCEL.png" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE WORD ------------------------------------------>
        <div *dxTemplate="let data of 'word'" class="foto">
          <a [href]="data.value">
            <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docword.png" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE POWER POINT ------------------------------------------>
        <div *dxTemplate="let data of 'powerpoint'" class="foto">
          <a [href]="data.value">
            <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/docPP.png" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE TXT ------------------------------------------>
        <div *dxTemplate="let data of 'txt'" class="foto">
          <a [href]="data.value">
            <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/doctxt.png" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE XML ------------------------------------------>
        <div *dxTemplate="let data of 'xml'" class="foto">
          <a [href]="data.value">
            <img id="myImg" class="preview-docs" src="../../../assets/images/iconos-utilerias/doctxt.png" />
          </a>
        </div>

        <!-- -------------------- TEMPLATE TOTAL DE REGISTROS ------------------------------------------>
        <div class="totalcolordetail" [ngClass]="{'totalcolorgris': Color.color === 'gris'}"
          *dxTemplate="let datadetail of 'Totalderegistrosdetail'">
          <div class="informer">
            <h2 class="totalcount">{{data.data.detalle ? data.data.detalle.length : 0}}</h2>
            <span class="name">Registros</span>
          </div>
        </div>

        <!-- -------------------- TEMPLATE REGISTROS SELECCIONADOS ------------------------------------------>
        <div class="countcolor" *dxTemplate="let datadetail of 'Contarseleccionadosdetail'">
          <div class="informer">
            <h2 class="countcount" id="contador">0</h2>
            <span class="countname">Seleccionados</span>
          </div>
        </div>
      </dx-data-grid>
    </div>

  </dx-data-grid>

</div>